const toValidDate = (value?: Date | string | null): Date | null => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * Month the calendar should open on when no start date is selected.
 * Stays on today when today is inside the role range. Otherwise opens on
 * the nearest month that still has a selectable day.
 */
export const getCalendarMonthInRange = (
  rangeStart?: Date | string | null,
  rangeEnd?: Date | string | null
): Date => {
  const today = new Date();
  const min = toValidDate(rangeStart);
  const max = toValidDate(rangeEnd);

  if (min && today < min) {
    return min;
  }
  if (max && today > max) {
    return max;
  }
  return today;
};
